// Web replacement for react-native-pdf: the browser's built-in PDF viewer in an iframe.
// TODO(pwa): iOS Safari shows only the first page in an iframe — switch to pdf.js.
import React, { useEffect } from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';

type Props = {
  source: { uri?: string } | string | number;
  style?: StyleProp<ViewStyle>;
  onLoadComplete?: (numberOfPages: number, path: string) => void;
  onPageChanged?: (page: number, numberOfPages: number) => void;
  onError?: (error: unknown) => void;
  [key: string]: unknown;
};

export default function Pdf({ source, style, onLoadComplete }: Props) {
  const uri = typeof source === 'object' ? source.uri ?? '' : String(source);

  useEffect(() => {
    if (uri) onLoadComplete?.(1, uri);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uri]);

  return (
    <View style={style}>
      <iframe src={uri} title="PDF" style={{ border: 0, width: '100%', height: '100%' }} />
    </View>
  );
}
